/* eslint-disable jsx-a11y/anchor-is-valid */
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import { Tooltip } from "antd";
import { TOOLTIP_BG } from "../../../../../modules/Common/constants";
import { Link } from "react-router-dom";
import { useSubheader } from "./../../../../../../_metronic/layout/_core/MetronicSubheader";

export function TilesWidget({
  className,
  data = {
    icon: "/media/svg/icons/Layout/Layout-4-blocks.svg",
    value: 790,
    title: "New Products",
    iconColor: "success",
    textColor:"#ffff"
  },
  value,
  onClick,
}) {
  const subheader = useSubheader();
  const custombreadcrumbs = [
    {
      title: "Reporting",
      pathname: "/reporting",
    },
  ];
  const setHeader = (breadcrumbs, title) => {
    subheader.setBreadcrumbs(breadcrumbs);
    subheader.setTitle(title);
  };

  const handleClick = () => {
    setHeader(custombreadcrumbs, "Business Reporting");
    const filters = JSON.parse(localStorage.getItem("fulfillment_search_filter"));
    // switch (data.title) {
    //   case "Delivery Orders":
    //     localStorage.setItem("shippingType", 2);
    //     filters.advance_filters.shippingType = "2";
    //     break;
    //   case "Pickup Orders":
    //     localStorage.setItem("shippingType", 1);
    //     filters.advance_filters.shippingType = "1";
    //     break;
    //   default:
    //     break;
    // }
    localStorage.setItem("fulfillment_search_filter", JSON.stringify(filters));
  };

  return (
    <>
      <div style={{ backgroundColor: `${data?.iconColor}`, color: `${data?.textColor}` }} className={`card card-custom bg-${data.iconColor} ${className}`} onClick={onClick}>
        <Link onClick={handleClick} to={data?.url}>
          <div className="card-body">
            <div style={{ position: "relative" }}>
              {data.tooltipContent && (
                <div
                  style={{
                    position: "absolute",
                    zindex: 1000,
                    width: 30,
                    height: "88%",
                    right: 1,
                    marginLeft: 3,
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  <Tooltip
                    trigger="hover"
                    placement="topLeft"
                    overlayStyle={{ maxWidth: "40%" }}
                    color={TOOLTIP_BG.color}
                    title={<p style={{ color: TOOLTIP_BG.textColor }}>{data.tooltipContent || "Tooltip content"}</p>}
                  >
                    <img src="/media/svg/icons/Shopping/information2-white.svg" />
                  </Tooltip>
                </div>
              )}
            </div>
            <div className="row justify-content-between align-items-center">
              <div className="col-12 col-md-auto">
                <span className={`svg-icon svg-icon-3x svg-icon-white ml-n2`}>
                  {data.tooltipContent ? (
                    <Tooltip
                      trigger="hover"
                      placement="topLeft"
                      overlayStyle={{ maxWidth: "40%" }}
                      color={TOOLTIP_BG.color}
                      title={<p style={{ color: TOOLTIP_BG.textColor }}>{data.tooltipContent || "Tooltip content"}</p>}
                    >
                      <SVG src={toAbsoluteUrl(data.icon)} />
                    </Tooltip>
                  ) : (
                    <SVG src={toAbsoluteUrl(data.icon)} />
                  )}
                </span>
                <br />
                <p style={{  color: `${data?.textColor}` }}
                 className={`text-inverse-${data.iconColor} font-weight-bold font-size-lg mt-1`}>{data.title}</p>
              </div>
              <div className="col-12 col-md-auto text-md-right text-md-left">
                <div style={{  color: `${data?.textColor}` }} className={`text-inverse-${data.iconColor} font-weight-bolder font-size-h1 mt-3`}>{value}</div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
}
